import React, { useContext } from "react";
import { DialogContext } from "./dialog_context";

function useDialog() {
  const { state, setState } = useContext(DialogContext);

  const open = (component) => {
    setState({
      show: true,
      component,
    });
  };
  const close = () => {
    setState({
      show: false,
      animalId: 0,
    });
  };
  return {
    open,
    isOpen: state.show,
    component: state.component,
    close,
  };
}
export default useDialog;
